import styled from '@emotion/styled'
import { useViewportSize } from '@mantine/hooks'
import useMobile from 'src/hooks/useMobile'
import DualLangHeader from '../components/DualLangHeader'
import {
  GeneralHeaderText, ColoredSpan, SmallText, Highlight
} from '../styles'
import { BuiltForYouSectionWrapper } from '../styles/BuiltForYouSection.styles'
import { QuestionsList, QuestionItem, QuestionText, AnswerText } from '../styles/CommonQuestionsSection.styles'

const CommonQuestionsHeaderText = styled(GeneralHeaderText)` 
  @media (max-width: 594px) { font-size: 2.75rem !important; }
  @media (max-width: 468px) { font-size: 2.25rem !important; }
  @media (max-width: 378px) { text-align: center; font-size: 2rem !important; }
  @media (max-width: 320px) { font-size: 1.75rem !important; }
`

const CommonQuestionsDualLangHeader = styled(DualLangHeader)`
  @media (max-width: 378px) {
    text-align: center;
  }
`

const CommonQuestionsSection = () => {
  const { width } = useViewportSize()
  const isMobile = useMobile()

  const shouldBreak = width > 814

  return (
    <BuiltForYouSectionWrapper>
      <CommonQuestionsDualLangHeader otherLang='자주 묻는 질문' style={{ padding: '24px 0' }}>
        <CommonQuestionsHeaderText>
          Common <ColoredSpan color='white'>Questions</ColoredSpan>
        </CommonQuestionsHeaderText>
      </CommonQuestionsDualLangHeader>
      <SmallText isMobile={isMobile} style={{ textAlign: isMobile ? 'left' : 'center', padding: '0 36px' }}>
        Created for students of {' '}
        <Highlight>every level and background</Highlight>,{' '}
        From Zero! is perfect for
        {shouldBreak ? <br/> : ' '}
        <ColoredSpan color='white'>absolute beginners as well as current students</ColoredSpan> of Korean!
      </SmallText>
      <QuestionsList isMobile={isMobile}>
        <QuestionItem>
          <QuestionText>What happened to KoreanFromZero.com?</QuestionText>
          <AnswerText>
            We have moved all the lessons to FromZero.com using a new and improved codebase.
            The server the current site was hosted on had reached its end of life and was no longer able to be updated.
            We have been planning the move for years, and the end of life of the server sped up the plan.
          </AnswerText>
        </QuestionItem>
        <QuestionItem>
          <QuestionText>Do I need a subscription to use the lessons now?</QuestionText>
          <AnswerText>
          Yes. While the first few lessons are free for every course, we have moved <i>Korean From Zero!</i> lessons to be part of the FromZero.com single subscription plan.
          For over 10 years, we have given away <i>Korean From Zero!</i> lessons for free on KoreanFromZero.com.
          It actually cost us money to give it away. Business-wise, it makes more sense to create revenue for the lessons we spent years crafting.
          The good news is there are great improvements to the content, including quizzes for each lesson, on the new subscription site.
          </AnswerText>
        </QuestionItem>
        <QuestionItem>
          <QuestionText>Was the company sold?</QuestionText>
          <AnswerText>
          No one asked this yet, but no--the company hasn’t changed at all!
          For over 25 years, we’ve been teaching languages, starting with Japanese.
          Our goal is to unify all the languages we teach under one website and give students full access for one price.
          </AnswerText>
        </QuestionItem>
        <QuestionItem>
          <QuestionText>I don’t have a credit card; how can I get access?</QuestionText>
          <AnswerText>
          Unfortunately, this is a problem we are unable to solve.
          In order to get a subscription, you will need a way to pay online.
          We accept PayPal and most credit cards with our Stripe integration.
          </AnswerText>
        </QuestionItem>
        <QuestionItem>
          <QuestionText>What are the plans for <i>Korean From Zero!</i>?</QuestionText>
          <AnswerText>
          Currently, Course 1 now has new quizzes for every lesson.
          During the beta phase, we will continue to add new quizzes until every lesson has one.
          We will eventually add our “Ask-a-Teacher” service, similar to how we have for the <i>Japanese From Zero!</i> courses.
          And we plan on adding Korean learning games that will match the style of the Japanese games.
          </AnswerText>
        </QuestionItem>
        <QuestionItem>
          <QuestionText>Will there be videos for each lesson?</QuestionText>
          <AnswerText>
            There are already some videos that will be integrated into the courses during the beta phase.
            Over time more videos will also be created for the courses similar to <i>Japanese From Zero!</i>.
          </AnswerText>
        </QuestionItem>
      </QuestionsList>
    </BuiltForYouSectionWrapper>
  )
}

export default CommonQuestionsSection
